import axios from "axios";

const API_BASE_URL = `${process.env.REACT_APP_URL_SIDE}/api`;

export const getDistrictWiseReport = async (month, year) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/report/district-wise`, {
      params: {
        month: month,
        year: year,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching district wise report:", error);
    throw error;
  }
};

export const getBlockWiseReport = async (distCode, month, year) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/report/block-wise`, {
      params: {
        distCode: distCode,
        month: month,
        year: year,
      },
    });
    return response.data;
  } catch (error) {
    console.error(
      `Error fetching block wise report for district ${distCode}:`,
      error
    );
    throw error;
  }
};

export const getFpsWiseReport = async (distCode, officeCode, month, year) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/report/fps-wise`, {
      params: {
        distCode: distCode,
        officeCode: officeCode,
        month: month,
        year: year,
      },
    });
    return response.data;
  } catch (error) {
    console.error(
      `Error fetching FPS wise report for block ${officeCode} in district ${distCode}:`,
      error
    );
    throw error;
  }
};

export const downloadDistrictWiseExcel = async (month, year) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/report/district-wise/download`,
      {
        params: { month, year },
        responseType: "blob",
      }
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `District_Wise_Report_${month}_${year}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading district wise Excel:", error);
    alert("Failed to download District Wise Excel report.");
  }
};

export const downloadBlockWiseExcel = async (distCode, month, year) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/report/block-wise/download`,
      {
        params: { distCode, month, year },
        responseType: "blob",
      }
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `Block_Wise_Report_Dist_${distCode}_${month}_${year}.xlsx`
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error(
      `Error downloading block wise Excel for district ${distCode}:`,
      error
    );
    alert("Failed to download Block Wise Excel report.");
  }
};

export const downloadFpsWiseExcel = async (
  distCode,
  officeCode,
  month,
  year,
  fpsId = ""
) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/report/fps-wise/download`,
      {
        params: { distCode, officeCode, month, year, fpsId },
        responseType: "blob",
      }
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    let fileName = `Detailed_FPS_Report_Dist_${distCode}_Block_${officeCode}`;
    if (fpsId && fpsId !== "") {
      fileName += `_FPS_${fpsId}`;
    }
    fileName += `_${month}_${year}.xlsx`;

    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error(
      `Error downloading FPS wise Excel for block ${officeCode} in district ${distCode}:`,
      error
    );
    alert("Failed to download FPS Wise Excel report.");
  }
};

// ----> Change Statement Report API (NEW) <---- //

const NEW_API_BASE_URL = `${process.env.REACT_APP_URL_SIDE}/api/new-report`;

export const getDistrictWiseReport_New = async (month, year, status) => {
  try {
    const response = await axios.get(`${NEW_API_BASE_URL}/district-wise`, {
      params: { month, year, status },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching new district wise report:", error);
    throw error;
  }
};

export const getBlockWiseReport_New = async (distCode, month, year, status) => {
  try {
    const response = await axios.get(`${NEW_API_BASE_URL}/block-wise`, {
      params: { distCode, month, year, status },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching new block wise report:", error);
    throw error;
  }
};

export const getFpsWiseReport_New = async (
  distCode,
  officeCode,
  month,
  year,
  status
) => {
  try {
    const response = await axios.get(`${NEW_API_BASE_URL}/fps-wise`, {
      params: { distCode, officeCode, month, year, status },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching new FPS wise report:", error);
    throw error;
  }
};

export const downloadDistrictWiseExcel_New = async (month, year, status) => {
  try {
    const response = await axios.get(
      `${NEW_API_BASE_URL}/district-wise/download`,
      {
        params: { month, year, status },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching district excel data:", error);
    throw error;
  }
};

export const downloadBlockWiseExcel_New = async (
  distCode,
  month,
  year,
  status
) => {
  try {
    const response = await axios.get(
      `${NEW_API_BASE_URL}/block-wise/download`,
      {
        params: { distCode, month, year, status },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching block excel data:", error);
    throw error;
  }
};

export const downloadFpsWiseExcel_New = async (
  distCode,
  officeCode,
  month,
  year,
  status,
  fpsId = ""
) => {
  try {
    const response = await axios.get(`${NEW_API_BASE_URL}/fps-wise/download`, {
      params: { distCode, officeCode, month, year, status, fpsId },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching FPS excel data:", error);
    throw error;
  }
};

export const downloadRawExcel_New = async (
  distCode,
  officeCode,
  month,
  year,
  status
) => {
  try {
    const response = await axios.get(`${NEW_API_BASE_URL}/raw/download`, {
      params: { distCode, officeCode, month, year, status },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching raw excel data:", error);
    throw error;
  }
};





// ----> RCMS Change Statement Report API <---- //

const RCMS_API_BASE_URL = `${process.env.REACT_APP_URL_MIS}/api/rcms-report`;

export const getRcmsDistrictWiseReport = async (month, year, status) => {
  const response = await axios.get(`${RCMS_API_BASE_URL}/district-wise`, { params: { month, year, status } });
  return response.data;
};

export const getRcmsBlockWiseReport = async (distCode, month, year, status) => {
  const response = await axios.get(`${RCMS_API_BASE_URL}/block-wise`, { params: { distCode, month, year, status } });
  return response.data;
};

export const getRcmsFpsWiseReport = async (distCode, officeCode, month, year, status) => {
  const response = await axios.get(`${RCMS_API_BASE_URL}/fps-wise`, { params: { distCode, officeCode, month, year, status } });
  return response.data;
};

export const downloadRcmsDistrictWiseExcel = async (month, year, status) => {
  const response = await axios.get(`${RCMS_API_BASE_URL}/district-wise/download`, { params: { month, year, status } });
  return response.data;
};

export const downloadRcmsBlockWiseExcel = async (distCode, month, year, status) => {
  const response = await axios.get(`${RCMS_API_BASE_URL}/block-wise/download`, { params: { distCode, month, year, status } });
  return response.data;
};

export const downloadRcmsFpsWiseExcel = async (distCode, officeCode, month, year, status, fpsId = "") => {
  const response = await axios.get(`${RCMS_API_BASE_URL}/fps-wise/download`, { params: { distCode, officeCode, month, year, status, fpsId } });
  return response.data;
};

export const downloadRcmsRawExcel = async (distCode, officeCode, month, year, status) => {
  const response = await axios.get(`${RCMS_API_BASE_URL}/raw/download`, { params: { distCode, officeCode, month, year, status } });
  return response.data;
};


// ----> RCMS Member Details Change Statement Report API <---- //

const RCMS_MEMBER_API_BASE_URL = `${process.env.REACT_APP_URL_MIS}/api/rcms-member-report`;

export const getRcmsMemberDistrictWiseReport = async (month, year, status) => {
  const response = await axios.get(`${RCMS_MEMBER_API_BASE_URL}/district-wise`, { params: { month, year, status } });
  return response.data;
};

export const getRcmsMemberBlockWiseReport = async (distCode, month, year, status) => {
  const response = await axios.get(`${RCMS_MEMBER_API_BASE_URL}/block-wise`, { params: { distCode, month, year, status } });
  return response.data;
};

export const getRcmsMemberFpsWiseReport = async (distCode, officeCode, month, year, status) => {
  const response = await axios.get(`${RCMS_MEMBER_API_BASE_URL}/fps-wise`, { params: { distCode, officeCode, month, year, status } });
  return response.data;
};

export const downloadRcmsMemberDistrictWiseExcel = async (month, year, status) => {
  const response = await axios.get(`${RCMS_MEMBER_API_BASE_URL}/district-wise/download`, { params: { month, year, status } });
  return response.data;
};

export const downloadRcmsMemberBlockWiseExcel = async (distCode, month, year, status) => {
  const response = await axios.get(`${RCMS_MEMBER_API_BASE_URL}/block-wise/download`, { params: { distCode, month, year, status } });
  return response.data;
};

export const downloadRcmsMemberFpsWiseExcel = async (distCode, officeCode, month, year, status, fpsId = "") => {
  const response = await axios.get(`${RCMS_MEMBER_API_BASE_URL}/fps-wise/download`, { params: { distCode, officeCode, month, year, status, fpsId } });
  return response.data;
};

export const downloadRcmsMemberRawExcel = async (distCode, officeCode, month, year, status) => {
  const response = await axios.get(`${RCMS_MEMBER_API_BASE_URL}/raw/download`, { params: { distCode, officeCode, month, year, status } });
  return response.data;
};

// ----> Member Details Change Statement Report API <---- //

const MEMBER_API_BASE_URL = `${process.env.REACT_APP_URL_MIS}/api/member-report`;

export const getMemberDistrictWiseReport = async (month, year, status) => {
  const response = await axios.get(`${MEMBER_API_BASE_URL}/district-wise`, { params: { month, year, status } });
  return response.data;
};

export const getMemberBlockWiseReport = async (distCode, month, year, status) => {
  const response = await axios.get(`${MEMBER_API_BASE_URL}/block-wise`, { params: { distCode, month, year, status } });
  return response.data;
};

export const getMemberFpsWiseReport = async (distCode, officeCode, month, year, status) => {
  const response = await axios.get(`${MEMBER_API_BASE_URL}/fps-wise`, { params: { distCode, officeCode, month, year, status } });
  return response.data;
};

export const downloadMemberDistrictWiseExcel = async (month, year, status) => {
  const response = await axios.get(`${MEMBER_API_BASE_URL}/district-wise/download`, { params: { month, year, status } });
  return response.data;
};

export const downloadMemberBlockWiseExcel = async (distCode, month, year, status) => {
  const response = await axios.get(`${MEMBER_API_BASE_URL}/block-wise/download`, { params: { distCode, month, year, status } });
  return response.data;
};

export const downloadMemberFpsWiseExcel = async (distCode, officeCode, month, year, status, fpsId = "") => {
  const response = await axios.get(`${MEMBER_API_BASE_URL}/fps-wise/download`, { params: { distCode, officeCode, month, year, status, fpsId } });
  return response.data;
};

export const downloadMemberRawExcel = async (distCode, officeCode, month, year, status) => {
  const response = await axios.get(`${MEMBER_API_BASE_URL}/raw/download`, { params: { distCode, officeCode, month, year, status } });
  return response.data;
};